function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.6
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint0_linear)",
  d: "M15.0653 1.5687C9.02003 -0.397159 2.53444 2.89638 0.568581 8.93647C-1.39853 14.9804 1.90269 21.466 7.9389 23.4293C13.9777 25.3977 20.4646 22.1016 22.4317 16.0628C24.3976 10.0151 21.099 3.53585 15.0653 1.5687Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint1_linear)",
  d: "M14.568 3.08519C9.36509 1.39284 3.78085 4.23438 2.08208 9.42959C0.390991 14.6338 3.23256 20.2219 8.43162 21.9104C13.6333 23.6091 19.2226 20.7676 20.9149 15.5698C22.6073 10.3631 19.7683 4.78012 14.568 3.08519Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint2_linear)",
  d: "M19.4608 11.655L16.8208 7.09159C16.8002 7.02866 16.7617 6.97474 16.7116 6.92336C16.5845 6.74487 16.3675 6.63574 16.1364 6.63574C15.8988 6.63574 15.7075 6.74487 15.5573 6.91694L15.452 7.09672L12.6092 12.0287L12.4808 12.256C12.4641 12.3292 12.4346 12.4113 12.4346 12.4986C12.4346 12.5898 12.4641 12.6656 12.4808 12.7503L12.6092 12.9673L14.2309 15.7858C14.3118 15.9052 14.3349 16.0272 14.3349 16.1492C14.3349 16.4034 14.2116 16.6461 13.9728 16.7822C13.6275 16.9876 13.1755 16.8644 12.9829 16.5151L12.147 15.1027L12.0904 14.9871C11.9621 14.8073 11.7412 14.6866 11.4973 14.6866C11.2585 14.6866 11.0363 14.8086 10.9092 14.9871L10.8514 15.1027L8.78155 18.662L8.77512 18.689C8.71352 18.8007 8.66211 18.9342 8.66211 19.0767C8.66211 19.4786 8.99856 19.8074 9.40044 19.8074H14.7433C15.2685 19.8074 15.9426 19.4298 16.1943 18.9663L19.4621 13.341C19.7214 12.8825 19.7214 12.1173 19.4608 11.655Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint3_linear)",
  d: "M10.514 12.7503C10.5333 12.6655 10.5653 12.5898 10.5653 12.4986C10.5653 12.4049 10.5332 12.3278 10.514 12.2559L10.3907 12.0286L8.76515 9.21661C8.68553 9.09592 8.66115 8.96493 8.66115 8.84811C8.66115 8.59517 8.78702 8.34094 9.02323 8.21123C9.3712 8.01092 9.81673 8.13035 10.0184 8.486L10.8504 9.88943L10.9082 10.0088C11.0353 10.1963 11.2574 10.3183 11.4963 10.3183C11.7403 10.3183 11.9611 10.195 12.0895 10.0088L12.146 9.89068L14.2133 6.33005L14.2223 6.31207C14.2878 6.19906 14.3365 6.06038 14.3365 5.91402C14.3365 5.51214 14.0001 5.19238 13.6175 5.19238H8.24767C7.7276 5.19238 7.05612 5.56476 6.80188 6.03213L3.53914 11.6549C3.27339 12.1171 3.27339 12.8824 3.53914 13.3421L6.17656 17.9055C6.2061 17.9659 6.23691 18.0275 6.28056 18.0763C6.41536 18.2535 6.62978 18.3691 6.86481 18.3691C7.0895 18.3691 7.29241 18.256 7.4388 18.084L7.54797 17.9004L10.3882 12.9671L10.514 12.7503Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint4_linear)",
  d: "M42.9885 12.3708C43.0038 12.1932 43.0038 12.0066 42.9885 11.8238C42.9578 11.4148 42.8568 11.0148 42.6804 10.7003L38.3105 3.15437C38.2849 3.08408 38.2351 3.02401 38.1916 2.96266L37.2777 1.38803C36.8573 0.623728 35.7427 0 34.8775 0H33.0089H25.9921H24.1222C23.2594 0 22.1437 0.623728 21.7231 1.38803L20.8106 2.96266C20.7659 3.0253 20.716 3.08537 20.6917 3.15437L16.3205 10.7003C16.1493 11.0071 16.0483 11.3969 16.0125 11.7983C15.9959 11.9976 15.9959 12.1996 16.0125 12.4028C16.047 12.8041 16.148 13.1888 16.3205 13.4956L17.499 15.5227L20.6904 21.0518C20.7351 21.1566 20.7889 21.2537 20.8656 21.3394C20.8732 21.3522 20.8873 21.3598 20.895 21.3739L21.7296 22.8067C22.1488 23.5761 23.2595 24.2049 24.135 24.2049H26.019H32.9821H34.8661C35.7416 24.2049 36.8548 23.5761 37.2727 22.8067L38.1074 21.3739C38.1163 21.3586 38.1278 21.3509 38.138 21.3394C38.2147 21.255 38.2684 21.1566 38.3118 21.0518L41.5033 15.5227L42.6817 13.4956C42.8568 13.1825 42.9578 12.785 42.9885 12.3708Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint5_linear)",
  d: "M40.9912 12.3326C41.0053 12.1818 41.0053 12.0221 40.9912 11.8674C40.9656 11.5172 40.8801 11.176 40.7279 10.9088L37.0061 4.47861C36.9843 4.41983 36.9409 4.36741 36.9038 4.31756L36.1254 2.9717C35.7675 2.32113 34.8167 1.79199 34.0805 1.79199H32.488H26.5077H24.9139C24.1777 1.79199 23.2281 2.32113 22.8701 2.9717L22.0931 4.31756C22.0547 4.36741 22.0113 4.41979 21.9908 4.47861L18.2664 10.9088C18.122 11.1708 18.0338 11.5031 18.0057 11.8444C17.9903 12.0144 17.9903 12.1869 18.0057 12.3607C18.0338 12.7007 18.122 13.0292 18.2664 13.2899L19.2697 15.0179L21.9895 19.7316C22.0291 19.8211 22.0738 19.9016 22.139 19.9757C22.1454 19.9846 22.1569 19.991 22.1646 20.0025L22.8753 21.2244C23.2332 21.8788 24.179 22.4143 24.9254 22.4143H26.5294H32.4625H34.0665C34.8129 22.4143 35.7613 21.8788 36.1166 21.2244L36.8285 20.0025C36.8362 19.9897 36.8464 19.9833 36.8541 19.9757C36.9193 19.9003 36.964 19.8211 37.0037 19.7316L39.7222 15.0179L40.7243 13.2899C40.8801 13.0228 40.9656 12.6842 40.9912 12.3326Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#paint6_linear)",
  d: "M34.4706 10.6887L30.9187 10.6862L28.08 10.6836H24.5294H24.5268C23.7446 10.6836 23.1094 11.3175 23.1094 12.0997C23.1094 12.8871 23.7433 13.5184 24.5268 13.5184L28.08 13.521L30.9187 13.5236H34.4706C35.254 13.5236 35.8906 12.8896 35.8906 12.1074C35.8918 11.3201 35.2554 10.6887 34.4706 10.6887Z",
  clipRule: "evenodd",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -13.0999,
  x2: 1.3446,
  y1: -18.9936,
  x1: 54.1559,
  id: "paint0_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: -7.78183,
  x2: -13.0394,
  y1: -12.8597,
  x1: 32.4453,
  id: "paint1_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 21.5159,
  x2: 12.0805,
  y1: 9.38413,
  x1: 2.61445,
  id: "paint2_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 22.31,
  x2: 10.6141,
  y1: 10.1835,
  x1: 1.14907,
  id: "paint3_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 2.09663,
  x2: 58.9473,
  y1: 40.7033,
  x1: 38.082,
  id: "paint4_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 14.9114,
  x2: 46.9616,
  y1: 47.8077,
  x1: 29.1885,
  id: "paint5_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#173048"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  y2: 20.7278,
  x2: 7.68789,
  y1: 10.9569,
  x1: 7.81632,
  id: "paint6_linear"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#17E2CF"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5181FD",
  offset: 1
})));

var SvgIconReduceCollateral = function SvgIconReduceCollateral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 43 25",
    height: 25,
    width: 43,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconReduceCollateral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_Reduce_Collateral.0195025d.svg";
export { ForwardRef as ReactComponent };